import * as z from "zod/v4";

const timePeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "last-month",
  "quarter",
  "all",
  "custom",
]);

const customRangeSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

const leaderboardEntrySchema_ = z.object({
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  department: z.string().optional(),
  totalOnboardings: z.number().int().min(0),
  weightedRevenueOnboarded: z.number().min(0),
  rank: z.number().int().min(1),
});

export const leaderboardEntrySchema: z.ZodType<LeaderboardEntry> =
  leaderboardEntrySchema_;
export interface LeaderboardEntry
  extends z.infer<typeof leaderboardEntrySchema_> {}

export const getOnboardingLeaderboard = {
  name: "getOnboardingLeaderboard" as const,
  input: z
    .object({
      timePeriod: timePeriodSchema,
      customRange: customRangeSchema.optional(),
      product: z.enum(["returns", "order-editing"]).optional(),
      limit: z.number().min(1).max(50).default(10),
    })
    .superRefine((value, ctx) => {
      if (value.timePeriod === "custom" && !value.customRange) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "customRange is required when timePeriod is custom",
          path: ["customRange"],
        });
      }
    }),
  output: z.object({
    entries: z.array(leaderboardEntrySchema),
    currentUserRank: z.number().int().min(1).nullable(),
    currentUserEntry: leaderboardEntrySchema.nullable(),
  }),
};

export type GetOnboardingLeaderboardInput = z.infer<
  typeof getOnboardingLeaderboard.input
>;
export type GetOnboardingLeaderboardOutput = z.infer<
  typeof getOnboardingLeaderboard.output
>;
